import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import ClockArrowUp from 'components/Icons/ClockArrowUp'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { withMarkers } from './withMarkers'

const t = buildTranslate('live_updates.scheduled_orders_banner')

const BANNER_PADDING = '18px 20px 18px 24px'
const BANNER_RADIUS = '4px'
const ICON_GAP = '8px'
const ICON_SIZE = 20

const SCHEDULED_ORDERS_MARKER = '[[scheduled_orders]]'
const ASAP_ORDERS_MARKER = '[[asap_orders]]'

const boldRun = (key: string, label: string) => (
  <Text.BodyText4 key={key} bold color="grey90">
    {label}
  </Text.BodyText4>
)

// Splices the one-sentence body's two bold runs in place of their markers
// (Figma 2838:23425) via the shared withMarkers helper.
const withBoldRuns = (copy: string): React.ReactNode =>
  withMarkers(copy, [
    [SCHEDULED_ORDERS_MARKER, boldRun('scheduled', t('scheduled_orders'))],
    [ASAP_ORDERS_MARKER, boldRun('asap', t('asap_orders'))],
  ])

// Scheduled-order live updates aren't supported yet — guests only ever
// receive them for ASAP orders until a separate upgrade ships — so this is a
// standing notice, not gated by a flag or any wire field (Figma 2838:23425).
// Sits directly below the page-level OloWebhookBanner and above the status
// sections.
const ScheduledOrdersBanner = () => {
  const [css] = useStyletron()

  return (
    <div
      data-testid="lu-scheduled-orders-banner"
      className={css({
        display: 'flex',
        alignItems: 'flex-start',
        gap: ICON_GAP,
        padding: BANNER_PADDING,
        borderRadius: BANNER_RADIUS,
        backgroundColor: palette.spearmint10,
      })}
    >
      {/* ClockArrowUp already sets aria-hidden on its own <svg> — no wrapper
          span needed. */}
      <ClockArrowUp fillColor={palette.grey90} size={ICON_SIZE} />
      <Text.BodyText4 color="grey90" className={css({ display: 'block' })}>
        {withBoldRuns(t('body'))}
      </Text.BodyText4>
    </div>
  )
}

export default ScheduledOrdersBanner
